:root ._dsp-flex{display:flex;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._pos-absolute{position:absolute;}
:root ._t-0px{top:0px;}
:root ._b-0px{bottom:0px;}
:root ._l-0px{left:0px;}
:root ._items-center{align-items:center;}
:root ._justify-center{justify-content:center;}
:root ._pl-0px{padding-left:0px;}
:root ._pl-23px{padding-left:23px;}
:root ._r-0px{right:0px;}
:root ._cur-pointer{cursor:pointer;}
:root ._pr-0px{padding-right:0px;}
:root ._pr-23px{padding-right:23px;}
:root ._items-stretch{align-items:stretch;}
:root ._pos-relative{position:relative;}
:root ._fd-row{flex-direction:row;}
:root ._gap-t-space-sma3456{gap:var(--t-space-small);}
:root ._width-24px{width:24px;}
:root ._bg-fff35{background-color:#fff;}
:root ._r-23px{right:23px;}